// extracted by mini-css-extract-plugin
module.exports = {"skeletonPage":"views-Skeleton__skeletonPage--36whv"};